import type {PostImage, OpenGraphMetadata, OpenGraphMetadataImage} from 'mattermost-redux/types/posts';

import {getNearestPoint} from './get_nearest_point';

const DIMENSIONS_NEAREST_POINT_IMAGE = {
    height: 80,
    width: 80,
};

export function getBestImageUrl(openGraphData?: OpenGraphMetadata, imagesMetadata?: Record<string, PostImage>) {
    if (!openGraphData?.images?.length) {
        return undefined;
    }

    // Get the dimensions from the post metadata if they weren't provided by the website as part of the OpenGraph data
    const images = openGraphData.images.map((image: OpenGraphMetadataImage) => {
        const imageUrl = image.secure_url || image.url;

        if ((image.width && image.height) || !(imagesMetadata && imagesMetadata[imageUrl])) {
            // The image already includes dimensions or we don't have the missing dimensions
            return image;
        }

        return {
            ...image,
            height: image.height || imagesMetadata[imageUrl].height,
            width: image.width || imagesMetadata[imageUrl].width,
        };
    });

    const bestImage = getNearestPoint<OpenGraphMetadataImage>(DIMENSIONS_NEAREST_POINT_IMAGE, images);
    return bestImage.secure_url || bestImage.url;
}
